import React from 'react'
import Select from './Select'

const ActionsSelect = ({ actions, row }) => {
  // Filter actions based on conditions
  const visibleActions = actions.filter(action => {
    if (typeof action.condition === 'function') {
      return action.condition(row)
    }
    return action.condition !== false
  })

  // Transform actions into options format for Select component
  const options = visibleActions
    .filter(action => action.key !== 'divider') // Skip dividers in select
    .map(action => ({
      value: action.key,
      label: action.label,
      disabled: false
    }))

  // Handle action selection
  const handleActionSelect = (selectedOption) => {
    if (!selectedOption || !selectedOption.value) return
    
    const selectedAction = visibleActions.find(action => action.key === selectedOption.value)
    if (selectedAction && selectedAction.onClick) {
      selectedAction.onClick(row)
    }
  }

  // Don't render if no actions available
  if (options.length === 0) {
    return <span>No actions available</span>
  }

  return (
    <Select
      value=""
      options={options}
      defaultOption={{ label: 'Actions' }}
      onSelect={handleActionSelect}
      containerClassName="actions-select"
      id={`actions-select-${row.id || Math.random()}`}
    />
  )
}

export default ActionsSelect
